import { useMemo } from 'react';
import { useGetExtractedNoticesQuery } from '../services/edgeApi';
import { usePaginatedResource } from './usePaginatedResource';

export const useExtractedNotices = (
  search: string,
  gasDate: string,
  filters?: { tsps: number[] },
) => {
  const _filters = useMemo(() => {
    return {
      tsps: filters?.tsps ?? [],
      gasDate: gasDate,
      limit: 10,
    };
  }, [filters, gasDate]);

  const payload = usePaginatedResource(
    useGetExtractedNoticesQuery,
    _filters,
    search,
  );

  return payload;
};
